import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ContentModel, SpecificationModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    content?: ContentModel;
    specifications?: SpecificationModel[];
    extendedStyles?: ProductDetailsDescriptionStyles;
}

export interface ProductDetailsDescriptionStyles {
    wrapper?: InjectableCss;
    content?: InjectableCss;
    descriptionWrapper?: InjectableCss;
    highlightsWrapper?: InjectableCss;
}

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    wrapper: {
        css: css``,
    },
    content: {
        css: css`
            color: ${getColor("text.main")};
            font-family: "LatoBold";
        `,
    },
    descriptionWrapper: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    highlightsWrapper: {
        css: css`
            margin-bottom: 15px;
            .product_highlights {
                list-style: disc;
                padding: 0 0 0 14px;
            }
        `,
    },
};

function getHtmlContent(htmlContent?: string) {
    if (!htmlContent) {
        return;
    }
    if (htmlContent.includes("<=")) {
        htmlContent = htmlContent.replace(/<=/g, "&lt=");
    }
    if (htmlContent.includes("=<")) {
        htmlContent = htmlContent.replace(/=</g, "=&lt");
    }
    if (htmlContent.includes(">=")) {
        htmlContent = htmlContent.replace(/>=/g, "&gt=");
    }
    if (htmlContent.includes("=>")) {
        htmlContent = htmlContent.replace(/=>/g, "=&gt");
    }
    return htmlContent;
}

const ProductSpecificationDescription: React.FC<OwnProps> = ({ content, specifications, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(descriptionStyles, extendedStyles));
    if (!content && !specifications) {
        return null;
    }

    const descriptionSpec = specifications?.find(spec => spec.name.toLowerCase() === "product description");
    const descriptionSpecHtmlContent = getHtmlContent(descriptionSpec?.htmlContent);

    const highlightSpec = specifications?.filter(spec => spec.name.toLowerCase().startsWith("product highlight"));

    const highlightSpecHtmlArray = highlightSpec?.map(spec => getHtmlContent(spec?.htmlContent));

    return (
        <StyledWrapper {...styles.wrapper}>
            {content && content.htmlContent && (
                <StyledWrapper {...styles.content} data-test-selector="productDetails_htmlContent">
                    {parse(content.htmlContent, parserOptions)}
                </StyledWrapper>
            )}
            {descriptionSpecHtmlContent && (
                <StyledWrapper {...styles.descriptionWrapper}>
                    {parse(descriptionSpecHtmlContent, parserOptions)}
                </StyledWrapper>
            )}
            {highlightSpecHtmlArray && highlightSpecHtmlArray.length > 0 && (
                <StyledWrapper {...styles.highlightsWrapper}>
                    <ul className="product_highlights">
                        {highlightSpecHtmlArray?.map((highlight, index) => (
                            <>{highlight ? <li key={index}>{parse(highlight, parserOptions)}</li> : null}</>
                        ))}
                    </ul>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default ProductSpecificationDescription;
